import { ModalWrapper } from 'src/components/ModalWrapper';
import { ShopModalContainer } from './components/ShopModalContainer';
import { MESSAGE_STATUS, useBuyItem, useMessageContext, useThrottle } from 'react-easyrocket';
import { Button } from 'src/components/Buttons/Button';
import { useTranslation } from 'react-i18next';
import { BuyMoney } from 'src/pages/Shop/AuthorizedShop/components/BuyMoney';
import { ModalProps } from './types';
import { useModalContext } from 'src/hooks/useModalContext';
import { THREE_SECONDS } from 'src/constants';

export const BuyMoneyModal = () => {
  const { closeModal, modalProps } = useModalContext<ModalProps>();
  const { mutateAsync: buyShopItem } = useBuyItem({});
  const { openMessage } = useMessageContext();
  const { t } = useTranslation();

  const handleBuyButtonClick = useThrottle(() => {
    closeModal();
    // eslint-disable-next-line camelcase
    modalProps?.item && buyShopItem({ item_id: modalProps?.item.id });
  }, THREE_SECONDS);

  return (
    <ModalWrapper showCross={false} isTransparentBg>
      <ShopModalContainer title="shop.bonusMoney" text="bonusPage.doYouWant">
        <div className="flex flex-col mb-[50px]">
          <BuyMoney item={modalProps?.item} />
          <Button
            className="w-[165px] self-center"
            onClick={() => {
              handleBuyButtonClick?.();
              openMessage?.(t('shop.successfully'), MESSAGE_STATUS.SUCCESS);
            }}>
            {t('accountBonus.accept')}
          </Button>
        </div>
      </ShopModalContainer>
    </ModalWrapper>
  );
};
